// extracted by mini-css-extract-plugin
module.exports = {"main":"Detail_main_NRNQd","img":"Detail_img_3B_QG","imgs":"Detail_imgs_1JVSb","price":"Detail_price_18bh0","details":"Detail_details_1jGw0"};